import React from 'react';
import '../template-file-css/document-file-template.css';



export const BTCS_CrisisPlan = ({
    itemsRef,
    showErrorFor,
    
}) => {

    return (
        <form id='BTCS_CrisisPlan' className='file-pdf-document'>
            <div className='file-template'>
            <p className='w-750'><h3>Crisis Plan</h3></p>

<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Date:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>BTCS Staff:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtStaff' name='txtStaff' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Client Name:</span></td>
        <td className='w-375'>
            <span className='eleHeader'>Date of Birth:</span></td>
    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtClientName' name='txtClientName' className='add-only' /></td>
        <td className='w-375'>
            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Step 1: Warning signs (thoughts, images, mood, situation, behavior) that a crisis may be developing:</span></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtWarningSign_1' name='txtWarningSign_1' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtWarningSign_2' name='txtWarningSign_2' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtWarningSign_3' name='txtWarningSign_3' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Step 2: Internal coping Strategies - Things I can do take my mind off my problems without contacting another person (relaxation technique, physical activity):</span></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtInternalCopingStrategies_1' name='txtInternalCopingStrategies_1' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtInternalCopingStrategies_2' name='txtInternalCopingStrategies_2' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtInternalCopingStrategies_3' name='txtInternalCopingStrategies_3' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Step 3: People and social settings that provide distraction:</span>
        </td>

    </tr>
    <tr>
        <td className='w-250'><b>Name</b></td>
        <td className='w-250'><b>Number</b></td>
        <td className='w-250'><b>Place</b></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='text' id='txtName_4' name='txtName_4' className='add-only' /></td>
        <td className='w-250'>
            <input type='text' id='txtNumber_5' name='txtNumber_5' className='add-only' /></td>
        <td className='w-250'>
            <input type='text' id='txtPlace_6' name='txtPlace_6' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-250'><b>Name:</b></td>
        <td className='w-250'><b>Number:</b></td>
        <td className='w-250'><b>Place:</b></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='text' id='txtName_7' name='txtName_7' className='add-only' /></td>
        <td className='w-250'>
            <input type='text' id='txtNumber_8' name='txtNumber_8' className='add-only' /></td>
        <td className='w-250'>
            <input type='text' id='txtPlace_9' name='txtPlace_9' className='add-only' /></td>
    </tr>

</table>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Step 4: People whom I can ask for help:</span>
        </td>
    </tr>
    <tr>
        <td className='w-375'><b>Name:</b></td>
        <td className='w-375'><b>Number:</b></td>

    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtName_9' name='txtName_9' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtNumber_10' name='txtNumber_10' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-375'><b>Name:</b></td>
        <td className='w-375'><b>Number:</b></td>

    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtName_11' name='txtName_11' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtNumber_12' name='txtNumber_12' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-375'><b>Name:</b></td>
        <td className='w-375'><b>Number:</b></td>

    </tr>
    <tr>
        <td className='w-375'>
            <input type='text' id='txtName_13' name='txtName_13' className='add-only' /></td>
        <td className='w-375'>
            <input type='text' id='txtNumber_14' name='txtNumber_14' className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Step 5: Professionals or agencies I can contact during a crisis:</span>
        </td>
    </tr>
    <tr>
        <td className='w-250'><b>Person/Agency</b></td>
        <td className='w-250'><b>Name:</b></td>
        <td className='w-250'><b>Contact Information:</b></td>
    </tr>
    <tr>
        <td className='w-250'>BTCS Therapist</td>
        <td className='w-250'>
            <input type='text' id='txtName_15' name='txtName_15' className='add-only' /></td>
        <td className='w-250'>
            <input type='text' id='txtContact_16' name='txtContact_16' className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-250'>BTCS Case Manager</td>
        <td className='w-250'>
            <input type='text' id='txtName_17' name='txtName_17' className='add-only' /></td>
        <td className='w-250'>
            <input type='text' id='txtContact_18' name='txtContact_18' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-250'>Local Police</td>
        <td className='w-250'>Emergency</td>
        <td className='w-250'>
            <input type='text' id='txtContact_19' name='txtContact_19' className='add-only' defaultValue={911} /></td>
    </tr>
    <tr>
        <td className='w-250'>Crisis Number</td>
        <td className='w-250'>Mobile Crisis</td>
        <td className='w-250'>
            <input type='text' id='txtContact_20' name='txtContact_20' className='add-only' defaultValue={2166236888} /></td>
    </tr>
    <tr>
        <td className='w-250'>Local Crisis Text Line</td>
        <td className='w-250'>Text Line</td>
        <td className='w-250'>
            <input type='text' id='txtContact_21' name='txtContact_21' className='add-only' defaultValue={741741} /></td>
    </tr>
    <tr>
        <td className='w-250'>Suicide Prevention Lifeline</td>
        <td className='w-250'>Suicide Prevention Lifeline</td>
        <td className='w-250'>
            <input type='text' id='txtContact_22' name='txtContact_22' className='add-only' defaultValue={18002738255} /></td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Step 6: Making the environment safe:</span>
        </td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtMakingTheEnvironmentSafe_23' name='txtMakingTheEnvironmentSafe_23' className='add-only'  /></td>
    </tr>
    <tr>
        <td className='w-750'>
            <input type='text' id='txtMakingTheEnvironmentSafe_24' name='txtMakingTheEnvironmentSafe_24' className='add-only'/></td>
    </tr>
</table>

<p className='w-750'>
    <input type='checkbox' id='cbIAttestThatThereIsNo_1' name='cbIAttestThatThereIsNo_1' className='add-only' value='Anger' /> I attest that there is no crisis for me, and no crisis plan is needed at this time
</p>

<table>
    <tr>
        <td className='signature w-500'>&nbsp; </td>
        <td className='signature w-250'>&nbsp; </td>
    </tr>
    <tr>
        <td className='small w-500'> Client Signature</td>
        <td className='small w-250'> Date</td>
    </tr>
</table>

<table>
    <tr>
        <td className='signature w-500'>&nbsp;</td>
        <td className='signature w-250'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-500'> BTCS Staff Signature</td>
        <td className='small w-250'> Date</td>
    </tr>
</table>



            


            </div>
        </form>

    )
}  
